<strong mat-dialog-title class="confirm_title dialogText">
  {{ title }}
</strong>

<div mat-dialog-content class="dialogText">
  <p>{{ message }}</p>
</div>

<div mat-dialog-actions class="padL16">
  <button name="yes" mat-raised-button color="primary" (click)="onConfirm()" (keyup.enter)="onConfirm()" tabindex="0">
    Yes
  </button>
  <button name="no" mat-button (click)="onDismiss()" (keyup.enter)="onDismiss()" tabindex="0">No</button>
</div>
